import React, { useState } from "react";
import { Modal, Box } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import LoginForm from "./LoginForm";
import "../../styles/LoginModal.scss";
import { IoCloseCircle } from "react-icons/io5";

function LogInModal({ open, onClose, onOpenRegister, onCloseRegister }) { 
  const [isRegisterOpen, setIsRegisterOpen] = useState(false);

  const handleOpenRegister = () => {
    onClose(); 
    setIsRegisterOpen(true); 
  };

  const handleCloseRegister = () => setIsRegisterOpen(false);
  return (
    <Modal 
      id="modalLogin"
      open={open} 
      onClose={onClose} 
      aria-labelledby="signin-modal-title"
      aria-describedby="signin-modal-description"
      sx={{ zIndex: 1000 }}>
      <Box 
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: '80%', md: 604 },
          maxWidth: '100%',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: '10px'
        }}>
        <IconButton className="modalCloseButton" onClick={onClose}>
          <IoCloseCircle />
        </IconButton>
        <div id="signin-modal-title">Iniciar Sesión</div>
        <hr></hr>
        <LoginForm onOpenRegister={onOpenRegister} source="modal" onCloseLogin={onClose} onCloseRegister={onCloseRegister}/>
      </Box>
    </Modal>
  );
}

export default LogInModal;